import React from 'react';
import LegalDraftPage from '../components/LegalDraftPage';
import { privacyDraft } from '../content/legalDrafts';

const PrivacyPolicyPage = () => <LegalDraftPage draft={privacyDraft} />;

export default PrivacyPolicyPage;
